import { useState } from 'react'
import ModalError from '../../components/atoms/ModalError'
import ModalSuccess from '../../components/atoms/ModalSuccess'
import FormCard from './FormCard'
import HeaderCard from './HeaderCard'
import { useSearchParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { userProfileAtom } from '../../store/userProfile'

const Card = () => {
  const [searchParams] = useSearchParams()
  const [userProfile] = useRecoilState(userProfileAtom)
  const [modal, setModal] = useState(searchParams.get('payment') || '')

  const closeModal = () => {
    setModal('')
  }

  return (
    <>
      {modal === 'success' && userProfile && (
        <ModalSuccess isModalOpen={true} closeModal={closeModal} />
      )}
      {modal === 'error' && userProfile && (
        <ModalError
          isModalOpen={true}
          closeModal={closeModal}
          onAgain={closeModal}
        />
      )}
      <div className='w-full'>
        <HeaderCard />
        <div className='md:w-[500px] md:mx-auto mx-4'>
          <FormCard />
        </div>
      </div>
    </>
  )
}
export default Card
